import { createElement } from 'react';
import GlobalNoteResolver from './GlobalNoteResolver';
import InstantNote from './InstantNote';
import { DEFAULT_TYPE, GLOBAL_NOTE_MAPPER, PUBLIC_NOTE_MAPPER } from './constants';

const noteResolverInscriptions: any = {
    [DEFAULT_TYPE]: GlobalNoteResolver,
    [PUBLIC_NOTE_MAPPER]: InstantNote,
    [GLOBAL_NOTE_MAPPER]: GlobalNoteResolver,
};

interface Props {
    type?: string;
    [key: string]: any;
}

const NoteResolver = ({ type, ...restProps }: Props) => {
    // Backward compatibility: infer type from common note fields if not provided
    const note = restProps?.note;
    const resolvedType =
        type ?? note?.classMapper ?? note?.mapper ?? note?.type ?? note?.data?.classMapper ?? DEFAULT_TYPE;

    return createElement(
        noteResolverInscriptions[resolvedType] ?? noteResolverInscriptions[DEFAULT_TYPE],
        restProps,
    );
};

export default NoteResolver;
